import React from 'react';

const Avatar = ({ image }) => <div className="profile__avatar" style={{ backgroundImage: `url('${image}')` }} />;

export default Avatar;
